export default "__VITE_ASSET__D7A1qp3L__"